import React, { Component } from "react";
import { Switch, BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";

// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/";
import AppRoute from "./routes/route";

import { BaseUrl } from "./helpers/Baseurl";

// layouts
import VerticalLayout from "./components/VerticalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

import Maintenance from "./pages/Utility/Maintenance";

// Import scss
import "./assets/scss/theme.scss";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			maintenance:false
		};
		this.getLayout = this.getLayout.bind(this);
		this.handleWindowBeforeUnload = this.handleWindowBeforeUnload.bind(this)
	}

	componentWillUnmount() {
		window.removeEventListener("beforeunload", this.handleWindowBeforeUnload);
	  }

	  handleWindowBeforeUnload(){
		localStorage.removeItem("user_permission")
	  }

	/**
   * Returns the layout
   */
	getLayout = () => {
		let layoutCls = VerticalLayout;

		
		return layoutCls;
	};
	componentDidMount(){
		this.checkUserPermissions()
		const requestOptions = {
			method: 'GET',
			headers: { 'Content-Type': 'application/json' },
		};
		fetch(`${BaseUrl}/api/itineraries/dashboard/`,requestOptions)
		.then(res => res.json())
		.catch(()=> {
			
			this.setState({maintenance:true})
		})
	}

	checkUserPermissions () {
		const obj = JSON.parse(localStorage.getItem("authUser"))
		if (obj?.user){

			if (!obj.user.is_superuser){
				let new_obj = obj
				const requestOptions = {
					method: 'GET',
					headers: { 'Content-Type': 'application/json' },
				};
				fetch(`${BaseUrl}/api/accounts/users/${obj.user.id}/`,requestOptions)
				.then(res => res.json())
				.then(
					(data) => {
						new_obj['user']['group'] = data.group
						localStorage.setItem("authUser", JSON.stringify(new_obj));
						// window.location.reload();
					},
					(error) => {
						console.log(error, 'error-------------')
						
					}
				) 

			}
		}
		

	}

	render() {
		const { maintenance } = this.state
		const Layout = this.getLayout();

		return (
			<React.Fragment>
				<Router>
					{maintenance?
					<Maintenance />
					:
					<div>
					<Switch>
						
						
						
						{publicRoutes.map((route, idx) => (
							<AppRoute
								path={route.path}
								layout={NonAuthLayout}
								component={route.component}
								key={idx}
								isAuthProtected={false}
							/>
						))}

						{authProtectedRoutes.map((route, idx) => (
							<AppRoute
								path={route.path}
								layout={Layout}
								component={route.component}
								key={idx}
								isAuthProtected={true}
							/>
						))}
					
					</Switch>
					</div>
					}
					
				</Router>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		layout: state.Layout
	};
};


export default connect(mapStateToProps, null)(App);
